import { ref } from 'vue';

export const isLoading = ref(false);

export function setLoading(value) {
    isLoading.value = value;
}
